import { FetchInterestEntriesQuery } from '../../../../generated'

export enum InterestEntriesSortBy {
  Date = 'date',
  BillId = 'billId',
  Principal = 'principal',
  AccruedInterest = 'accruedInterest',
  CumulativeInterest = 'cumulativeInterest',
  Rate = 'rate',
  Days = 'days'
}

export enum InterestEntriesSortDir {
  Asc = 'asc',
  Desc = 'desc'
}

export interface InterestEntriesFilters {
  billId?: number
  clientId?: string
  caseId?: string
  fromDate?: string
  toDate?: string
  sortBy?: InterestEntriesSortBy
  sortDir?: InterestEntriesSortDir
}

export interface InterestEntriesState {
  interestEntries: NonNullable<FetchInterestEntriesQuery['fetchInterestEntries']['interestEntries']>
  loading: boolean
}

export const interestEntriesInitialState: InterestEntriesState = {
  interestEntries: [],
  loading: false
}

export enum InterestEntriesActionType {
  SET_INTEREST_ENTRIES = 'setInterestEntries',
  SET_LOADING = 'setLoading'
}

export type InterestEntriesAction =
  | {
      type: InterestEntriesActionType.SET_INTEREST_ENTRIES
      interestEntries: NonNullable<FetchInterestEntriesQuery['fetchInterestEntries']['interestEntries']>
    }
  | { type: InterestEntriesActionType.SET_LOADING; loading: boolean }

export const interestEntriesReducer = (
  state: InterestEntriesState,
  action: InterestEntriesAction
): InterestEntriesState => {
  switch (action.type) {
    case InterestEntriesActionType.SET_INTEREST_ENTRIES:
      return {
        ...state,
        interestEntries: action.interestEntries
      }

    case InterestEntriesActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    default:
      return state
  }
}
